import React, { Component } from 'react';
import { Form, Formik } from 'formik'
import onboarding from 'assets/images/onboarding.png'
import RouteConst from '../../../../constants/RouteConst'
import * as FormConst from '../../../../constants/FormConst'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import MasterBoxConfigurationService from '../../../../services/MasterBoxConfigurationService'
import { isArrayNotEmpty } from '../../../../utilities/JSUtil'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import TextAreaInput from '../../../atoms/form/TextAreaInput/TextAreaInput'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import * as Yup from 'yup';
import './MasterBoxConfiguration.scss';

export class MasterBoxConfiguration extends Component {

    constructor(props) {
        super(props)

        this.state = {
            masterBoxes: [],
            uniqueBoxNames: [],
            isAdd: false,
            isEdit: false,
            isDelete: false,
            isLoading: true,
            showErrorModal: false,
            errorMessage: undefined,
            currentMasterBox: undefined,
            currentMasterBoxIndex: undefined,
            regionBoxNamesMap: {},
            parentBoxNamesOptions: []
        }

    }

    // To submit the add and edit forms from the form modal buttons which is outside of formik
    submitForm = null;

    handleSubmitForm = (data) => {
        if (this.submitForm) {
            this.submitForm(data);
        }
    }

    bindSubmitForm = (submitForm) => {
        this.submitForm = submitForm;
    }

    validationSchema = Yup.object().shape({
        boxName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.MASTER_BOX_BOX_NAME_MAX_LENGTH, `Up to ${FormConst.MASTER_BOX_BOX_NAME_MAX_LENGTH} characters allowed`),
        description: Yup.string().trim().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .max(FormConst.MASTER_BOX_DESCRIPTION_MAX_LENGTH, `Up to ${FormConst.MASTER_BOX_DESCRIPTION_MAX_LENGTH} characters allowed`),
    })

    async componentDidMount() {
        await MasterBoxConfigurationService.getMasterBoxes()
            .then((response) => {
                const uniqueBoxNames = [...new Set(response.map((entry) => entry.boxName))]
                const regionBoxNamesMap = {};
                const emptyRegionBoxNamesOptions = this.buildEmptyRegionBoxNamesOptions(response)

                response.forEach(box => {
                    this.addRegionBoxNameToMap(box, regionBoxNamesMap);
                });

                this.setState({
                    masterBoxes: response,
                    uniqueBoxNames: uniqueBoxNames,
                    regionBoxNamesMap: regionBoxNamesMap,
                    parentBoxNamesOptions: emptyRegionBoxNamesOptions,
                    emptyRegionBoxNamesOptions: emptyRegionBoxNamesOptions,
                    isLoading: false
                })
            })
            .catch(() => {
                this.setState({
                    isLoading: false, 
                    showErrorModal: true,
                    errorMessage: 'Error while fetching master boxes.'
                })
            })
    }

    buildEmptyRegionBoxNamesOptions = (boxes) => {
        let options = [];
        boxes.forEach(box => {
            if(!box.region) {
                options.push({label: box.boxName, value: box.boxName})
            }
        })
        return options;
    }

    addRegionBoxNameToMap = (box, regionBoxNamesMap) => {
        if (box.region) {
            if (!regionBoxNamesMap[box.region]) {
                regionBoxNamesMap[box.region] = [];
            }
            regionBoxNamesMap[box.region].push({ label: box.boxName, value: box.boxName });
        }
    }

    handleRegionChange = (e, formikProps) => {
        const selectedRegion = e.target.value;
        let parentBoxNamesOptions = this.state.regionBoxNamesMap[selectedRegion] || [];
        parentBoxNamesOptions = parentBoxNamesOptions.concat(this.state.emptyRegionBoxNamesOptions)

        this.setState({ parentBoxNamesOptions: parentBoxNamesOptions });
        formikProps.setFieldValue('parentBoxName', '');
        formikProps.handleChange(e);
    }

    doAdd = (data) => {
        this.setState({ isAdd: false, isLoading: true })
        data.boxName = data.boxName.trim().toUpperCase()
        if(data.region === '') {
            delete data.region
        }

        if(data.parentBoxName === '') {
            delete data.parentBoxName
        }

        MasterBoxConfigurationService.addMasterBox(data)
            .then(() => {
                let masterBoxes = [...this.state.masterBoxes]
                let regionBoxNamesMap = this.state.regionBoxNamesMap
                masterBoxes.push(data)
                let emptyRegionBoxNamesOptions = this.buildEmptyRegionBoxNamesOptions(masterBoxes)

                let uniqueBoxNames = [...this.state.uniqueBoxNames]
                if (!this.state.uniqueBoxNames.includes(data.boxName)) {
                    uniqueBoxNames.push(data.boxName)

                }

                this.addRegionBoxNameToMap(data, regionBoxNamesMap);

                this.setState({
                    masterBoxes: masterBoxes,
                    uniqueBoxNames: uniqueBoxNames,
                    emptyRegionBoxNamesOptions: emptyRegionBoxNamesOptions,
                    regionBoxNamesMap: regionBoxNamesMap,
                    isLoading: false
                });
            }).catch((error) => {
                let msg = 'Error while adding master box.'
                if (error.messages[0].code === 'MASTER_BOX_ALREADY_EXISTS') {
                    msg = msg + ' Master box with the same box name and region already exists.'
                } else if (error.messages[0].code === 'PARENT_MASTER_BOX_DOES_NOT_EXIST') {
                    msg = msg + ' The parent master box for this region does not exists.'
                } else if (error.messages[0].code === 'MASTER_BOX_PARENT_BOX_NAME_SAME_AS_BOX_NAME') {
                    msg = msg + ' The parent master box name is the same as the box name.'
                }
                this.setState({
                    showErrorModal: true,
                    errorMessage: msg,
                    isLoading: false
                })
            })
    }

    doUpdate = (data) => {
        this.setState({ isEdit: false, currentMasterBox: undefined, isLoading: true })
        if (this.isDisplayDisabled(data)) {
            data.display = false;
        }

        MasterBoxConfigurationService.updateMasterBox(data)
            .then(() => {
                let masterBoxes = [...this.state.masterBoxes]
                masterBoxes[this.state.currentMasterBoxIndex] = data
                if (!data.parentBoxName && data.display === true) {
                    for (let box of masterBoxes) {
                        if (box.parentBoxName === data.boxName && box.region === data.region) {
                            box.display = false;
                        }
                    }
                }

                this.setState({
                    masterBoxes: masterBoxes,
                    currentMasterBox: undefined,
                    isLoading: false
                });
            }).catch((error) => {
                let msg = 'Error while updating master box.'
                if (error.messages[0].code === 'PARENT_MASTER_BOX_DOES_NOT_EXIST') {
                    msg = msg + ' The parent master box for this region does not exists.'
                } else if (error.messages[0].code === 'MASTER_BOX_PARENT_BOX_NAME_SAME_AS_BOX_NAME') {
                    msg = msg + ' The parent master box name is the same as the box name.'
                }
                this.setState({
                    showErrorModal: true,
                    errorMessage: msg,
                    currentMasterBoxIndex: undefined,
                    isLoading: false
                })
            })
    }

    doDelete = () => {
        this.setState({ isDelete: false, isLoading: true })

        MasterBoxConfigurationService.deleteMasterBox(this.state.currentMasterBox)
            .then(() => {
                let regionBoxNamesMap = {}
                let masterBoxes = [...this.state.masterBoxes]
                masterBoxes.splice(this.state.currentMasterBoxIndex, 1);
                let emptyRegionBoxNamesOptions = this.buildEmptyRegionBoxNamesOptions(masterBoxes)

                let uniqueBoxNames = [...this.state.uniqueBoxNames]
                const boxNameStillInUse = masterBoxes.map(box => box.boxName).includes(this.state.currentMasterBox.boxName)

                if (!boxNameStillInUse) {
                    const index = uniqueBoxNames.indexOf(this.state.currentMasterBox.boxName)
                    uniqueBoxNames.splice(index, 1)
                }


                masterBoxes.forEach(box => {
                    this.addRegionBoxNameToMap(box, regionBoxNamesMap);
                });

                this.setState({
                    masterBoxes: masterBoxes,
                    uniqueBoxNames: uniqueBoxNames,
                    emptyRegionBoxNamesOptions: emptyRegionBoxNamesOptions,
                    regionBoxNamesMap: regionBoxNamesMap,
                    currentMasterBox: undefined,
                    currentMasterBoxIndex: undefined,
                    isLoading: false
                });
            }).catch((error) => {
                let msg = 'Error while deleting master box.'
                if (error.messages[0].code === 'MASTER_BOX_HAS_CHILDREN') {
                    msg = msg + ' Master box has boxes linked to it.'
                }

                this.setState({
                    showErrorModal: true,
                    errorMessage: msg,
                    currentMasterBox: undefined,
                    currentMasterBoxIndex: undefined,
                    isLoading: false
                })
            })
    }

    redirectToConfigure = () => {
        this.props.history.push(RouteConst.ROUTE_LAUNCH_CONFIGURE_PAGE)
    }

    handleDisplayChange = (e, formikProps) => {
        if (this.isDisplayDisabled(formikProps.values)) {
            // If display is disabled, do not allow changing its value
            return;
        } else {
            return formikProps.handleChange(e);
        }
    }

    isDisplayDisabled = (values) => {
        if (!values.parentBoxName) {
            return false;
        }

        const parentBox = this.state.masterBoxes.find(box =>
            box.boxName === values.parentBoxName &&
            box.region === values.region
        );

        if (parentBox && parentBox.display) {
            values.display = false;
        }

        return parentBox && parentBox.display;
    }

    render() {

        return (
            <div className='master-box-configuration-page'>
                <img id='page-logo' src={onboarding} className='onboarding-img' />
                
                <div className='master-boxes'>

                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />
                            
                    <p id='master-box-page-info' className='master-box-header'>{FormConst.MODAL_MASTER_BOX_TITLE}</p>

                    <div className='master-box-buttons'>
                        <Button 
                            id='master-box-add-button' 
                            name={'(+) Add Master Box'} 
                            className='add-button' 
                            onClick={() => this.setState({ isAdd: true, parentBoxNamesOptions: this.state.emptyRegionBoxNamesOptions })} />
                    </div>

                    <table id='master-box-table' className='table table-striped master-box-table'>
                        <thead>
                            <tr>
                                <th>Box Name</th>
                                <th>Description</th>
                                <th>Display</th>
                                <th>Participation Mandatory</th>
                                <th>Parent Box Name</th>
                                <th>Region</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                isArrayNotEmpty(this.state.masterBoxes)
                                    ? (
                                        this.state.masterBoxes.map((masterBox, index) =>
                                            <tr key={index}>
                                                <td>{masterBox.boxName}</td>
                                                <td>{masterBox.description}</td>
                                                <td>{masterBox.display ? '1' : '0'}</td>
                                                <td>{masterBox.participationMandatory ? '1' : '0'}</td>
                                                <td>{masterBox.parentBoxName}</td>
                                                <td>{masterBox.region}</td>
                                                <td><Button name={<FaEdit />} role='link' className='icon-link' 
                                                    onClick={() => {
                                                        const region = masterBox.region || '';
                                                        let parentBoxNamesOptions = this.state.regionBoxNamesMap[region] || []
                                                        parentBoxNamesOptions = parentBoxNamesOptions.concat(this.state.emptyRegionBoxNamesOptions);
                                                        this.setState({
                                                            isEdit: true,
                                                            currentMasterBox: masterBox,
                                                            currentMasterBoxIndex: index,
                                                            parentBoxNamesOptions: parentBoxNamesOptions
                                                        });
                                                    }}/>
                                                </td>
                                                <td><Button name={<FaTrashAlt />} role='link' className='icon-link'
                                                        onClick={() => this.setState({ isDelete: true, currentMasterBox: masterBox, currentMasterBoxIndex: index })}/>
                                                </td>
                                            </tr>
                                        )
                                    )
                                    : (
                                        <tr>
                                            <td colSpan={6} className='text-center'>No master boxes found.</td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>

                    <Button 
                        id='configure-page-button' 
                        name='Go to configuration page' 
                        className='configure-button' 
                        onClick={this.redirectToConfigure} />

                    <FormModal
                        id='master-box-add-edit-modal'
                        title={FormConst.MODAL_MASTER_BOX_DETAILS}
                        body={
                            <div id='master-box-add-update'>
                                <Formik
                                    initialValues={{
                                        boxName: this.state.currentMasterBox ? this.state.currentMasterBox.boxName : "",
                                        description: this.state.currentMasterBox ? this.state.currentMasterBox.description : "",
                                        display: this.state.currentMasterBox ? this.state.currentMasterBox.display : false,
                                        participationMandatory: this.state.currentMasterBox ? this.state.currentMasterBox.participationMandatory : false,
                                        parentBoxName: this.state.currentMasterBox ? this.state.currentMasterBox.parentBoxName : undefined,
                                        region: this.state.currentMasterBox ? this.state.currentMasterBox.region : undefined
                                    }}
                                    validationSchema={this.validationSchema}
                                    onSubmit={(data, { setSubmitting }) => {
                                        setSubmitting(true)
                                        this.state.isEdit ? this.doUpdate(data) : this.doAdd(data)
                                        setSubmitting(false)
                                    }}>
                                    {(formikProps) => {
                                        const { values, handleChange } = formikProps;
                                        this.bindSubmitForm(formikProps.submitForm);

                                        return (
                                            <Form id='master-box-update-form'>
                                                <TextInput id='boxName' name='boxName' type='text' label='Box Name' autoCapitalize='characters' isrequired='true' 
                                                            onChange={handleChange} disabled={this.state.isEdit} style={{ 'text-transform': 'uppercase' }} />
                                                
                                                <TextAreaInput id='description' name='description' label='Description' className='master-box-description' isrequired='true'
                                                    maxLength={FormConst.MASTER_BOX_DESCRIPTION_MAX_LENGTH} rows={8} onChange={handleChange} />
                                                <p className='float-right'>Characters left: {FormConst.MASTER_BOX_DESCRIPTION_MAX_LENGTH - values.description.length}</p>

                                                <SelectInput id='region' name='region' key='region' label='Region'  options={FormConst.REGION_OPTIONS}
                                                             onChange={(e) => this.handleRegionChange(e, formikProps)}  disabled={this.state.isEdit}/>

                                                <SelectInput name='parentBoxName' id='parentBoxName' key='parentBoxName' label='Parent Box Name' options={this.state.parentBoxNamesOptions}
                                                             onChange={handleChange} isrequired='false'/>

                                                <ToggleSwitch id='display' name='display' label='Display' checked={values.display} options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                    overridedisabledflag='true' disabled={this.isDisplayDisabled(values)} onChange={(e) => this.handleDisplayChange(e, formikProps)} />

                                                <ToggleSwitch id='participationMandatory' name='participationMandatory' label='Participation Mandatory'
                                                    checked={values.participationMandatory} options={FormConst.SWITCH_OPTIONS_YES_NO} overridedisabledflag='true'
                                                    disabled={false} onChange={handleChange} />

                                            </Form>
                                        )
                                    }}
                                </Formik>
                            </div>
                        }
                        show={this.state.isEdit || this.state.isAdd}
                        proceed={this.handleSubmitForm}
                        proceedName={FormConst.ACTION_SAVE}
                        cancel={() => this.setState({ isAdd: false, isEdit: false, currentMasterBox: undefined, currentMasterBoxIndex: undefined }) }
                        size='xl'
                        hideLogo/>

                    <FormModal
                        id='master-box-delete-confirmation-modal'
                        title={FormConst.MODAL_MASTER_BOX_TITLE}
                        body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                        show={this.state.isDelete}
                        proceed={() => this.doDelete()} 
                        cancel={() => this.setState({ isDelete: false, currentMasterBox: undefined, currentMasterBoxIndex: undefined }) }/>

                    <FormModal
                        id='master-box-page-loading-modal'
                        title={FormConst.MODAL_READ_ACTION_TITLE}
                        body={<h6>{FormConst.MODAL_READ_ACTION_TEXT}</h6>}
                        show={this.state.isLoading}
                        isLoadingIndicator />

                    <FormModal
                        id='master-box-page-error-modal'
                        title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                        body={<h5>{this.state.errorMessage}</h5>}
                        show={this.state.showErrorModal}
                        cancel={() => { this.setState({ showErrorModal: false, errorMessage: undefined }) }}
                        isError />

                </div>
            </div>
        )
    }
}

export default MasterBoxConfiguration
